export const REQUEST_REGISTRY_PATH = "/request-registry";
